import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'core-js/stable/symbol';

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import store from 'src/redux/store';
import GlobalStyle from 'components/_utility/GlobalStyle/GlobalStyle';
import App from './App';
import theme from './lib/theme';

const render = () => {
  const rootEl = document.getElementById('dealer-locator-root');
  const contentApiEndpoint = rootEl.dataset.apiEntrypoint;
  const { basepath } = rootEl.dataset;

  ReactDOM.render(
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <>
          <GlobalStyle />
          <App contentApiEndpoint={contentApiEndpoint} basepath={basepath} />
        </>
      </ThemeProvider>
    </Provider>,
    document.getElementById('dealer-locator-root')
  );
};

render();
